export default __webpack_public_path__ + "static/media/racebook-no-cr-on-dark.269ca7f0.png";